import request from '../utils/request';

// 查询员工下拉列表
export function staffListApi(  Authorization) {
  return request({
    url: '/api/chatChart/chart/staff/list',
    method: 'get',
    headers: {
      "authorization": Authorization
    }
  }, true)
}

// 分页查询聊天情况图表（每日）
export function chartPageApi(params, Authorization) {
  return request({
    url: '/api/chatChart/chart/page',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  }, true)
}

// 沟通视图聊天摘要
export function summaryViewApi(data, Authorization) {
  return request({
    url: '/api/model/summaryView',
    method: 'post',
    data,
    headers: {
      "authorization": Authorization
    }
  }, true)
}

